import type { FaireProductEntity } from "../../entity_types/product";

export const p_c4jxabxzz8: FaireProductEntity = {
  token: "p_c4jxabxzz8",
  type: "product",
  name: "Amber & Moss - 12.5 oz Large Concentrated Candle",
  brandToken: "b_a9b3b023",
  brandName: "P.F. Candle Co.",
  imageUrl:
    "https://cdn.faire.com/fastly/69c5f0b8808a806ac7ddb87bd43132dc811525072f7b6f3de15f3d644422e790.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/9721e4ccb3a55de69b5557952dd2e4743a30e9fdaf4070f55da2445d8896ea3d.jpeg",
    "https://cdn.faire.com/fastly/3efe85f46381e5932c0f1338dd6653ad4108161120c9cc01e74a2f9b8b4e7c4f.jpeg",
    "https://cdn.faire.com/fastly/930d91bac09b052734c629b64b9da2cfb97d6d04a1fd5243f4f9db921336b7db.jpeg",
    "https://cdn.faire.com/fastly/d7e9c3e1e0e45b9c88ee9682f55a4f2d4bb40dcaf8e21f00751e03d2585ef7da.jpeg",
    "https://cdn.faire.com/fastly/afbe679981c3d3e032816803c911acc1445fb493b8af6041a885784071de9717.jpeg",
    "https://cdn.faire.com/fastly/2c0513b366ce92444a1ba54c40ea2665868f10ed7e7aa4b35faecbd9760f7e3f.jpeg",
  ],
  priceDollars: 18,
  description:
    "A weekend in the mountains, sun gleaming through the canopy. \nNotes of sage, moss, and lavender.\n\nIntroducing our new and reformulated Large Concentrated Candles – we took our best-selling Classic Line scents and increased the fragrance level for stronger throw in your biggest spaces.\n\nOur 12.5 oz Large Candles are hand-poured into apothecary-inspired amber jars with our signature kraft label and a brass lid. \n\nOur candles are simple - they're all made with 100% domestically grown soy wax, fine fragrance oils, and cotton-core wicks. The fragrances we use are paraben-free, phthalate-free, and never (ever) tested on animals.\n\nBurns for 60-70 hours.",
  tags: [],
  msrpDollars: 37.99,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-07-01T19:03:50.497Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
